import axios from 'axios';

export const inboxQueryParams = ({ filter, messageTypes, projectIds, supplierId, q, cursor, limit } = {}) => {
  const params = {};
  if (filter === 'unread') params.filter = filter;
  if (messageTypes && messageTypes.length) params.messageTypes = messageTypes.join(',');
  if (projectIds && projectIds.length) params.projectIds = projectIds.join(',');
  if (supplierId) params.supplierId = supplierId;
  if (q) params.q = q;
  if (cursor) params.cursor = cursor;
  if (limit) params.limit = limit;
  return params;
};

export const ServiceInbox = {
  getInbox: async (options = {}) => {
    const response = await axios.get('/api/inbox', { params: inboxQueryParams(options) });
    return response.data;
  },
};
